import { useI18n } from '../i18n.tsx';
import type { VerificationStatus } from '../types.ts';

export function StatusBadge({
  status,
  title,
}: {
  status: VerificationStatus;
  title?: string;
}) {
  const { t } = useI18n();
  return (
    <span className={`badge s-${status}`} title={title ?? t.statusHelp[status]}>
      <span className="dot" aria-hidden="true" />
      {t.statusLabels[status]}
    </span>
  );
}
